import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { InfoButtonContext } from "../InfoButton"
import styles from "./Label.module.scss"

enum SizePreset {
  small = "labelSmall",
  large = "labelLarge",
}

type SizePresetKey = keyof typeof SizePreset
export const defaultSizePreset: SizePresetKey = "large"

export interface Props extends ComponentPropsWithoutRef<"label"> {
  sizePreset?: SizePresetKey;
}

export const Label = forwardRef<HTMLLabelElement, Props>(
  function Label(props: Props, propRef: Ref<HTMLLabelElement>) {
    const {
      sizePreset = defaultSizePreset,
      children,
      ...htmlLabelProps
    } = props

    const className = classNames(
      props.className,
      styles[SizePreset[sizePreset]],
    )

    // automatically style any infoButtons based on the current sizePreset
    const infoButtonContextValue = useMemo(
      () => ({
        sizePreset,
      }),
      [sizePreset],
    )

    return (
      <label
        {...htmlLabelProps}
        htmlFor={htmlLabelProps.htmlFor}
        className={className}
        ref={propRef}
      >
        <InfoButtonContext.Provider value={infoButtonContextValue}>
          {children}
        </InfoButtonContext.Provider>
      </label>
    )
  },
)
